import React from 'react';
import { DownloadIcon, ListChecksIcon, PartyPopperIcon, PrinterIcon } from 'lucide-react';
type Step = {
  title: string;
  text: string;
  icon: React.ElementType;
  /** Color del ícono y de su fondo */
  chip: string;
};
const stepsCopy = {
  eyebrow: 'Fácil de preparar y disfrutar',
  title: '¡Tu Baby Shower listo en 4 simples pasos!',
  subtitle: 'Sin inventar juegos desde cero ni pasar horas buscando ideas.'
};
const babyShowerSteps: Step[] = [{
  title: 'Descargá el material',
  text: 'Accedé a los juegos y elegí la versión rosa o celeste.',
  icon: DownloadIcon,
  chip: 'bg-[#FDE3EC] text-[#E74D7A]'
}, {
  title: 'Elegí tus favoritos',
  text: 'Combiná juegos imprimibles y dinámicas según tu celebración.',
  icon: ListChecksIcon,
  chip: 'bg-[#DDF2F1] text-[#15ADA8]'
}, {
  title: 'Prepará los juegos',
  text: 'Imprimí lo necesario y seguí las instrucciones.',
  icon: PrinterIcon,
  chip: 'bg-[#FDE3EC] text-[#E74D7A]'
}, {
  title: '¡A disfrutar!',
  text: 'Compartí risas y momentos especiales con tus invitados.',
  icon: PartyPopperIcon,
  chip: 'bg-[#DDF2F1] text-[#15ADA8]'
}];
export function FourSteps() {
  return <section aria-labelledby="steps-title" className="bg-[#FAF0E7] py-11 md:py-16" data-id="element-119" data-mp="xwb4saa6zw68">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-120" data-mp="12110nz4upar5">
        <header className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="16ykfp19dhrk5">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-122" data-mp="16y16c8xsgbhq">
            {stepsCopy.eyebrow}
          </p>
          <h2 id="steps-title" className="mx-auto mt-4 max-w-[22ch] font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-123" data-mp="j8q22hh8byyu">
            {stepsCopy.title}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[16px] leading-relaxed text-body md:mt-4 md:text-[17px]" data-id="element-124" data-mp="3mnvrkanc0tlo">
            {stepsCopy.subtitle}
          </p>
        </header>

        <ol className="mx-auto mt-6 grid max-w-4xl grid-cols-1 gap-2.5 min-[400px]:grid-cols-2 md:mt-8 lg:grid-cols-4 lg:gap-3" data-id="element-125" data-mp="yt04nt5az76z">
          {babyShowerSteps.map(({
          title,
          text,
          icon: Icon,
          chip
        }, i) => <li key={title} className="relative flex flex-col rounded-2xl border border-[#EFE4D6] bg-white p-3.5 shadow-[0_8px_22px_-20px_rgba(139,107,85,0.45)] lg:p-4" data-id="element-126" data-mp="13l9piurk9h2e" data-mpi={i}>
              <span className="absolute right-3 top-2.5 font-display text-[12px] font-bold tabular-nums text-[#B8957C] lg:right-3.5 lg:top-3" aria-hidden="true" data-id="element-127" data-mp="fvyxq2s6ux0e">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="flex items-center gap-2.5 pr-6" data-id="element-128" data-mp="jxainv04au29">
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl ${chip}`} aria-hidden="true" data-id="element-129" data-mp="jvzdbqr0xe91">
                  <Icon className="h-4 w-4" strokeWidth={1.6} data-id="element-130" data-mp="1vcha5ryj9iw7" />
                </span>
                <h3 className="font-display text-[15px] font-bold leading-tight text-[#4A3A35]" data-id="element-131" data-mp="1vek0kd3lle1g">
                  <span className="sr-only" data-id="element-132" data-mp="23vklvba04flj">Paso {i + 1}: </span>
                  {title}
                </h3>
              </div>
              <p className="mt-2 text-[13.5px] leading-snug text-body sm:text-[14px]" data-id="element-133" data-mp="1tvk0ljsknpep">{text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}